import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/themeColors';

interface CTACardProps {
  onClose: () => void;
}

const CTACard_5: React.FC<CTACardProps> = ({ onClose }) => {
  const { isDark, isHighContrast } = useTheme();
  const colors = getThemeColors('dark', isDark, isHighContrast);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de fazer uma cotação de seguro auto. Vi as avaliações e fiquei interessado!');
    window.open(`https://wa.me/41764791479?text=${message}`, '_blank');
  };

  return (
    <div style={{
      background: `linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)`,
      borderRadius: 16,
      padding: 'clamp(1.5rem, 4vw, 2rem)',
      margin: 'clamp(1.5rem, 4vw, 2rem) 0',
      position: 'relative',
      overflow: 'hidden',
      color: 'white',
      border: '2px solid #FF6B35'
    }}>
      {/* Animated Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%)',
        animation: 'shimmer 2s infinite',
        zIndex: 0
      }} />
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.8rem'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              animation: 'pulse 2s infinite'
            }}>
              ⚡
            </div>
            <div>
              <h3 style={{
                fontSize: 'clamp(1.2rem, 3.5vw, 1.5rem)',
                fontWeight: 700,
                margin: 0,
                lineHeight: 1.2
              }}>
                ATENÇÃO: Oferta Limitada!
              </h3>
              <p style={{
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                margin: '0.3rem 0 0 0',
                opacity: 0.9
              }}>
                Termina em 24 horas
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              fontSize: '1.2rem',
              color: 'white',
              cursor: 'pointer',
              padding: '0.5rem',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              backdropFilter: 'blur(10px)'
            }}
          >
            ✕
          </button>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'clamp(1rem, 3vw, 1.5rem)',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, minWidth: '250px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.8rem',
              flexWrap: 'wrap'
            }}>
              <span style={{
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '0.3rem 0.8rem',
                borderRadius: 20,
                fontSize: 'clamp(0.7rem, 2vw, 0.8rem)',
                fontWeight: 600,
                backdropFilter: 'blur(10px)'
              }}>
                🔥 PROMOÇÃO ESPECIAL
              </span>
              <span style={{
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '0.3rem 0.8rem',
                borderRadius: 20,
                fontSize: 'clamp(0.7rem, 2vw, 0.8rem)',
                fontWeight: 600,
                backdropFilter: 'blur(10px)'
              }}>
                ⏰ ÚLTIMAS HORAS
              </span>
            </div>
            
            <p style={{
              fontSize: 'clamp(1rem, 2.8vw, 1.1rem)',
              margin: '0 0 1rem 0',
              lineHeight: 1.4,
              opacity: 0.95
            }}>
              <strong>Desconto de 10%</strong> para novos clientes que contratarem hoje! 
              Compare preços e economize no seu seguro auto.
            </p>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
              marginBottom: '1rem'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                opacity: 0.9
              }}>
                <span>✅</span>
                <span>Cotação gratuita</span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                opacity: 0.9
              }}>
                <span>✅</span>
                <span>Sem compromisso</span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                opacity: 0.9
              }}>
                <span>✅</span>
                <span>Atendimento 24h</span>
              </div>
            </div>
          </div>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.8rem',
            minWidth: '200px'
          }}>
            <button
              onClick={handleWhatsAppClick}
              style={{
                background: 'white',
                color: '#FF6B35',
                border: 'none',
                borderRadius: 12,
                padding: 'clamp(1rem, 3vw, 1.2rem) clamp(1.5rem, 4vw, 2rem)',
                fontSize: 'clamp(1rem, 2.8vw, 1.1rem)',
                fontWeight: 700,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                animation: 'bounce 2s infinite'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
              }}
            >
              <span style={{ fontSize: '1.3rem' }}>💬</span>
              QUERO O DESCONTO!
            </button>
            
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                color: 'white',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderRadius: 12,
                padding: 'clamp(0.8rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
              }}
            >
              Talvez Depois
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-5px); }
          60% { transform: translateY(-3px); }
        }
      `}</style>
    </div>
  );
};

export default CTACard_5; 